import Pqp from "../3x1010/Pqp.js";
import PageCommon from "./PageCommon.js";

export default class PageDefault extends PageCommon {

  constructor() {
    super();

  }

  init() {


    this.box0 = { idle: 1, smile: 3, sad: 3, url: "sei.html" }
    this.box1 = { idle: 1, smile: 1, sad: 3, url: "goth.html" }
    this.box2 = { idle: 1, smile: 1, sad: 3, url: "manager.html" }

    this.initBoxes()

    jQuery(".js-preloader").css("background-color", "transparent");
    jQuery(".js-main").css("background-image", "url('assets/home_bg.jpg')");

    setTimeout(this.spostaTitolo.bind(this), 2000);

  }

  spostaTitolo() {
    
    TweenMax.to(jQuery(".js-preloader"), 0.5, { opacity: 0 });
    if (Pqp.isMobile()) {
      TweenMax.to(jQuery(".title"), 1, { top: "5%", onComplete: this.showBoxes.bind(this) });
    } else {
      TweenMax.to(jQuery(".title"), 1, { top: "10%", onComplete: this.showBoxes.bind(this) });
    }
  }

  showBoxes() {
    PageCommon.showPreloader(false);
    for (let x = 0; x < 3; x++) {
      let box = jQuery(".js-box-" + x);
      box.show();
      box.css("opacity", 0);
      TweenMax.to(box, 0.5, { opacity: 1, delay: x * 0.25, onComplete:this.abilitaClick.bind(this,x) });

    }

  }
  abilitaClick(n) {
    if (n === 2) {
      for (let x = 0; x < 3; x++) {
        let box = jQuery(".js-box-" + x);
        box.css("pointer-events","all")
      }

      TweenMax.to(jQuery(".footer"), 0.5, { opacity: 1 });
    }
  }

  initBoxes() {
    for (let x = 0; x < 3; x++) {
      let box = jQuery(".js-box-" + x);
      box.hide();
      jQuery(".img-her", box).attr("src", this.getDir() + "box" + x + "/" + this.getIdle(x));
      if (!Pqp.isMobile()) {
        box.on("mouseenter", this.onOver.bind(this, x))
        box.on("mouseleave", this.onOut.bind(this, x))
      }
      box.on("click", this.onClick.bind(this, x))

    }

  }

  getDir() {
    return "assets/home/";
  }

  getIdle(box) {
    return "idle" + Pqp.rnd(this["box" + box].idle - 1) + ".jpg";
  }
  getSmile(box) {
    return "smile" + Pqp.rnd(this["box" + box].smile - 1) + ".jpg";
  }
  getCry(box) {
    return "sad" + Pqp.rnd(this["box" + box].sad - 1) + ".jpg";
  }
  getLink(box) {
    return this["box" + box].url;
  }

  onOver(n) {
    let boxSmile = n;
    let boxCry1;
    let boxCry2;
    if (n === 0) {
      boxCry1 = 1;
      boxCry2 = 2;
    } else if (n === 1) {
      boxCry1 = 0;
      boxCry2 = 2;
    } else {
      boxCry1 = 0;
      boxCry2 = 1;
    }
    jQuery(".js-emote", jQuery(".js-box-" + boxSmile)).attr("src", this.getDir() + "box" + boxSmile + "/" + this.getSmile(boxSmile));
    jQuery(".js-emote", jQuery(".js-box-" + boxCry1)).attr("src", this.getDir() + "box" + boxCry1 + "/" + this.getCry(boxCry1));
    jQuery(".js-emote", jQuery(".js-box-" + boxCry2)).attr("src", this.getDir() + "box" + boxCry2 + "/" + this.getCry(boxCry2));
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + boxSmile)), 0.3, { opacity: 1 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + boxCry1)), 0.3, { opacity: 1 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + boxCry2)), 0.3, { opacity: 1 });
  }

  onOut(n) {
    //jQuery("img", jQuery(".js-box-" + 0)).attr("src", this.getDir() + "box" + 0 + "/" + this.getIdle(0));
    //jQuery("img", jQuery(".js-box-" + 1)).attr("src", this.getDir() + "box" + 1 + "/" + this.getIdle(1));
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + 0)), 0.3, { opacity: 0 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + 1)), 0.3, { opacity: 0 });
    TweenMax.to(jQuery(".js-emote", jQuery(".js-box-" + 2)), 0.3, { opacity: 0 });
  }

  onClick(n) {
    window.location.href = this.getLink(n)

  }


}


